import { Utils } from '../features/utils'
import { VoiceModelLicense } from '../types'

export const MAX_VOICE_MODEL_IMAGE_SIZE = Utils.Bytes.toBytes(20, 'MB')

export const LICENSE_INFO_URL = 'https://help.kits.ai/hc/en-us/sections/25498104936595-Legal'

export const VERIFIED_VOICES_URL = 'https://www.kits.ai/verified-voices'

export const LICENSE_INFO_TOOLTIP = {
  [VoiceModelLicense.ROYALTY_FREE]:
    'Royalty-free models on Kits have no rights restrictions and can be used commercially in any creative medium without obligation.',
  [VoiceModelLicense.ROYALTIES_APPLIED]:
    ' Artist models on Kits are personal use only and require artist approval for any commercially released works.'
}
